import { render } from "./VideoAnimation.vue?vue&type=template&id=0432a013"
import script from "./VideoAnimation.vue?vue&type=script&lang=js"
export * from "./VideoAnimation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__